import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import TalentPosition from './TalentPosition';
// Using FontAwesome kit via <i> tags
import './TalentSearch.css';

const UnlockedProfiles = ({
  unlockedProfiles,
  remainingCredits,
  onBackToSearch,
  onProfileClick
}) => {
  useUiLanguage();
  const { language } = useLanguage();
  // Set page title
  useEffect(() => {
    document.title = "Unlocked Profiles - JOBSEEQR | Talent Search Engine";
  }, []);

  return (
  <div className="results-section">
    <div className="unlocked-profiles-header">
      {remainingCredits > 0 && (
        <button
          className="back-to-search-button"
          onClick={onBackToSearch}
        >
          <i className="fa-solid fa-arrow-left"></i>{uiText(" Back to Search")}</button>
      )}
      <h2 className="subtitle" style={{ marginTop: '40px' }}>{uiText("Unlocked Profiles")}</h2>
      <p className="description">
        {remainingCredits === 0
          ? uiText("Since you ran out of profile credits and cannot search more, we are showing the profiles you have unlocked. To search more, please purchase additional credits.")
          : uiText("Your unlocked profiles are displayed below.")}
      </p>
    </div>
    <div className="profile-navigation">
      <div className="gallery">
        {unlockedProfiles.length === 0 ? (
          <p>{uiText("No profiles have been unlocked yet.")}</p>
        ) : (
          unlockedProfiles.map((profile, index) => (
            <div
              key={index}
              id={profile.metadata.pinecone_id}
              className="profile-card"
              onClick={() => onProfileClick(profile)}
            >
              <p className="personName">{profile.metadata.username}</p>
              <p className="profile-card-info"><TalentPosition metadata={profile.metadata} language={language} /></p>
              <div className="profile-card-tag-cntr">
                {profile.metadata.openToWork && (
                  <div className="open-to-work-pill">{uiText("Open to Work")}</div>
                )}
                {profile.metadata.tags.slice(0, 4).map((tag, idx) => (
                  <div key={idx} className="profile-card-tag">
                    {tag}
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </div>
  );
};

export default UnlockedProfiles;
